export const cardBoxStyles = {};

export const cardItemPerfilPacienteStyles = {
  marginBottom: "10px",
  display: "flex",
  flexDirection: "column",
};

export const h5PerfilPacienteStyles = {
  margin: "0",
  display: "flex",
  alignItems: "center",
};

export const pPerfilPacienteStyles = {
  fontSize: "12px",
  margin: "0",
};

export const cardMedicamentos = {
  marginBottom: "10px",
  display: "flex",
  flexDirection: "column",
};

export const cardMedicamentosContent = {
  display: "flex",
  alignItems: "center",
};

export const h5MedicamentosStyles = {
  margin: "0",
  display: "flex",
  alignItems: "center",
};

export const pMedicamentosStyles = {
  fontSize: "12px",
  margin: "0",
};

export const HeartIcon = () => (
  <span
    className="fas fa-heartbeat"
    style={{
      fontSize: "16px",
      color: "grey",
      marginRight: "0.5em",
    }}
  ></span>
);

export const DownloadIcon = () => (
  <span
    className="fas fa-download"
    style={{
      fontSize: "16px",
      marginLeft: "1em",
    }}
  ></span>
);

export const ClipIcon = () => (
  <span
    className="fas fa-paperclip"
    style={{
      fontSize: "16px",
      marginLeft: "1em",
    }}
  ></span>
);
